/*
 * @Author: Gao Deng gaodeng@nextmar.com
 * @Date: 2025-04-17 18:29:43
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-08-21 18:47:51
 * @FilePath: /code/zeelool-nextjs/src/components/Product/ProductCardMedia.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { EProductImageType } from '@/utils/enums/goods';
import { EPlatform } from '@/utils/enums/platform-enum';
import type { HoverProductImagePriority, ProductImagePriority } from '@/hooks/useProductImages';
import React from 'react';
import ProductCardImg from './ProductCardImg';
import ProductTag from './ProductTag';
import Wish from './Wish';

interface IProductCardMediaProps {
  product: any;
  deviceType: EPlatform;
  isAcc?: boolean;
  mode?: 'NORMAL' | 'MANAGE' | 'OTHER';
  showWishNum?: boolean;
  showWish?: boolean; // 是否展示收藏按钮
  showTag?: boolean; // 是否展示商品标签
  loginSituation?: string;
  wished?: () => void;
  removed?: () => void;
  collectScene?: string;
  /** 收藏坑位 SPM 编码（favorite_NNN）；由商品卡片按页面作用域解析，缺省不附加。 */
  favoriteSpmCnt?: string;
  imageRule?: EProductImageType[];
  imageHoverRule?: EProductImageType[];
  productImagePriority?: ProductImagePriority;
  hoverProductImagePriority?: HoverProductImagePriority;
  SoldOutBlock: React.ReactNode;
  TryOnButton: React.ReactNode;
  isSquare?: boolean; // 是否为正方形
  className?: string;
  frameWidth?: string;
  productImageWhiteBg?: boolean;
  /** 可选的图片左上角标签，提供时替代默认商品标签。 */
  topLeftLabel?: React.ReactNode;
}

const ProductCardMedia: React.FC<IProductCardMediaProps> = ({
  product,
  deviceType,
  isAcc = false,
  mode = 'NORMAL',
  showWishNum = false,
  showWish = true,
  showTag = true,
  loginSituation = '',
  wished = () => {},
  removed = () => {},
  collectScene = '其它',
  favoriteSpmCnt,
  imageRule = [EProductImageType.PRODUCT, EProductImageType.MATERIAL, EProductImageType.CELEBRITY],
  imageHoverRule = [
    EProductImageType.MATERIAL,
    EProductImageType.CELEBRITY,
    EProductImageType.PRODUCT,
  ],
  productImagePriority,
  hoverProductImagePriority,
  SoldOutBlock,
  TryOnButton,
  isSquare = false,
  className = '',
  frameWidth = '80%',
  productImageWhiteBg = false,
  topLeftLabel,
}) => {
  const getAspectRatioClass = () => {
    if (deviceType === EPlatform.WEB) {
      return `rounded-12 ${isSquare ? 'aspect-square' : 'aspect-[504/378]'}`;
    }
    return 'aspect-[186/223]';
  };
  return (
    <div
      className={`ProductImageContainer group relative w-full ${productImageWhiteBg ? 'bg-white' : 'bg-auxiliary-light-gray'} overflow-hidden ${getAspectRatioClass()} ${className}`}
    >
      <ProductCardImg
        productData={product}
        imageRule={imageRule}
        imageHoverRule={imageHoverRule}
        productImagePriority={productImagePriority}
        hoverProductImagePriority={hoverProductImagePriority}
        isAcc={isAcc}
        frameWidth={frameWidth}
        productImageWhiteBg={productImageWhiteBg}
      />
      <div
        className={`absolute top-0 left-0 w-full flex items-center justify-between z-1 ${deviceType === EPlatform.WEB ? 'p-[16px]' : topLeftLabel ? 'py-6 pl-8 pr-6' : 'p-[6px]'}`}
      >
        {/* 左侧标签区域 - 即使不展示标签也要保持占位 */}
        <div
          className={`flex h-[24px] items-center ${topLeftLabel ? 'min-w-0 max-w-[calc(100%-32px)]' : ''}`}
        >
          {topLeftLabel || (showTag && <ProductTag product={product} />)}
        </div>
        {/* 右侧收藏按钮区域 */}
        {mode === 'NORMAL' && showWish && (
          <Wish
            data={product}
            className={`flex items-center leading-[24px] text-auxiliary-dark-gray ${deviceType === EPlatform.WEB ? 'text-14' : 'text-12'}`}
            wishNumClassName="ml-2 text-14"
            iconClassName={`text-14`}
            showWishNum={showWishNum}
            loginSituation={loginSituation}
            wished={wished}
            removed={removed}
            collectScene={collectScene}
            spmCnt={favoriteSpmCnt}
          />
        )}
      </div>
      {SoldOutBlock}
      {TryOnButton}
    </div>
  );
};

export default ProductCardMedia;
